export const ChatBotModes = {
    regular: 'Regular',
    directToTrainer: 'Direct-To-Trainer'
};
